// extracted by mini-css-extract-plugin
export default {"ageRangeBlock":"AgeRangeSelection_ageRangeBlock__ucLWi","removeAgeRangeButtonWrapper":"AgeRangeSelection_removeAgeRangeButtonWrapper__lFdHw"};